const teacherConstants = {
  GET_TEACHERS_REQUEST: 'GET_TEACHERS_REQUEST',
  GET_TEACHERS_SUCCESS: 'GET_TEACHERS_SUCCESS',
  GET_TEACHERS_FAILURE: 'GET_TEACHERS_FAILURE',
};

export default teacherConstants;
